import customAxios from "../../customAxios";
import { ADMIN_GET_PAYEMNT_ONLINE_2_COMPANY } from "../../routes";
import {PaymentOnline2CompanyNamespace} from "../../../types/paymentOnline2Company.namespace";

const getPaymentOnline2Company = async (
  {page = 1, limit = 10, company, payerType, academicYear}: PaymentOnline2CompanyNamespace.IGetFactorAdmin
) => {
  let thisUrl: string = ADMIN_GET_PAYEMNT_ONLINE_2_COMPANY + `?page=${page}&limit=${limit}`;

  if (company  ) thisUrl += `&company=${company}`
  if (payerType) thisUrl += `&payerType=${payerType}`

  // ?? Academic year (سال تحصیلی) scope
  if (academicYear) thisUrl += `&academicYear=${academicYear}`

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ ADMIN_GET_PAYEMNT_ONLINE_2_COMPANY: error });
  }
};

export default getPaymentOnline2Company;
